/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetGroup200ResponseItemsInner } from './GetGroup200ResponseItemsInner';
import {
    GetGroup200ResponseItemsInnerFromJSON,
    GetGroup200ResponseItemsInnerFromJSONTyped,
    GetGroup200ResponseItemsInnerToJSON,
    GetGroup200ResponseItemsInnerToJSONTyped,
} from './GetGroup200ResponseItemsInner';
import type { ListOperations200ResponsePaging } from './ListOperations200ResponsePaging';
import {
    ListOperations200ResponsePagingFromJSON,
    ListOperations200ResponsePagingFromJSONTyped,
    ListOperations200ResponsePagingToJSON,
    ListOperations200ResponsePagingToJSONTyped,
} from './ListOperations200ResponsePaging';

/**
 * 
 * @export
 * @interface GetGroup200Response
 */
export interface GetGroup200Response {
    /**
     * 
     * @type {Array<GetGroup200ResponseItemsInner>}
     * @memberof GetGroup200Response
     */
    items?: Array<GetGroup200ResponseItemsInner>;
    /**
     * 
     * @type {ListOperations200ResponsePaging}
     * @memberof GetGroup200Response
     */
    paging?: ListOperations200ResponsePaging;
}

/**
 * Check if a given object implements the GetGroup200Response interface.
 */
export function instanceOfGetGroup200Response(value: object): value is GetGroup200Response {
    return true;
}

export function GetGroup200ResponseFromJSON(json: any): GetGroup200Response {
    return GetGroup200ResponseFromJSONTyped(json, false);
}

export function GetGroup200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetGroup200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(GetGroup200ResponseItemsInnerFromJSON)),
        'paging': json['paging'] == null ? undefined : ListOperations200ResponsePagingFromJSON(json['paging']),
    };
}

export function GetGroup200ResponseToJSON(json: any): GetGroup200Response {
    return GetGroup200ResponseToJSONTyped(json, false);
}

export function GetGroup200ResponseToJSONTyped(value?: GetGroup200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(GetGroup200ResponseItemsInnerToJSON)),
        'paging': ListOperations200ResponsePagingToJSON(value['paging']),
    };
}

